import convertTimestampToShamsi from '@/common/utils/convertTimestampToShamsi';
import {
  IBodyVisitInformationResponseType,
  IBodyVisitInformationTypeParams,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyVisitInformation/getBodyVisitInformationQuer.type';
import { getBodyVisitInformationQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyVisitInformation/getBodyVisitInformationQueryFunction';
import { queryOptions } from '@tanstack/react-query';

const getBodyVisitInformationQueryOption = (
  params: IBodyVisitInformationTypeParams,
) =>
  queryOptions({
    queryKey: ['get_vehicle_damage_amount', params],
    queryFn: () => getBodyVisitInformationQueryFunction(params),
    select: (data: IBodyVisitInformationResponseType) => {
      return {
        ...data,
        visit_date: convertTimestampToShamsi(Number(data?.visit_date)),
        visit_site: {
          label: data?.visit_site?.fa_const,
          value: data?.visit_site?.const,
        },
        visit_location: data?.visit_location,
      };
    },
  });
export default getBodyVisitInformationQueryOption;
